export default {
  title: {
    en: 'Deal ends in:',
  },
  time: {
    en: '{time}',
  },
}
